import { render, staticRenderFns } from "./PropertyDetailsView.vue?vue&type=template&id=015ddc86&scoped=true"
import script from "./PropertyDetailsView.vue?vue&type=script&lang=js"
export * from "./PropertyDetailsView.vue?vue&type=script&lang=js"
import style0 from "./PropertyDetailsView.vue?vue&type=style&index=0&id=015ddc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ddc86",
  null
  
)

export default component.exports